import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { LOCAL_STORAGE_KEYS } from 'utils/constants/localStorageKeys';
import { useTranslation } from 'utils/modifiedTranslation';
import app from 'new-ui/app';
import { sendDoctorEmail } from 'modules/matches/api';
import { ShareWithDoctorPopup } from './ShareWithDoctorPopup';

const prepareRequestPayload = ({ formData: { doctorFirstName, doctorLastName, doctorEmail }, patientUserWixId }) => ({
  doctorFirstName,
  doctorLastName,
  doctorEmail,
  patientUserWixId,
});

export const ShareWithMyDoctor = ({ closePopup }) => {
  const { t } = useTranslation();
  const [isSent, setIsSent] = useState(false);

  const handleSubmit = (formData) => {
    app.showPreloader();
    sendDoctorEmail(prepareRequestPayload({ formData }))
      .then(() => {
        localStorage.setItem(LOCAL_STORAGE_KEYS.DOCTOR_SHARED, '1');
        setIsSent(true);
        app.updateUserConfiguration({
          lastShareWithDoctor: new Date().toISOString(),
        });
        setTimeout(async () => {
          closePopup();
        }, 3000);
      })
      .finally(() => {
        app.hidePreloader();
      });
  };

  return (
    <ShareWithDoctorPopup
      title={t('share_with_doctor.title')}
      onSubmit={handleSubmit}
      isSent={isSent}
    />
  );
};

ShareWithMyDoctor.propTypes = {
  closePopup: PropTypes.func.isRequired,
};
